var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKeyboardArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#151B26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 14.7504C9.70146 14.7504 9.4028 14.6364 9.17506 14.4089L2.00878 7.24237C1.5529 6.7865 1.5529 6.04739 2.00878 5.5917C2.46445 5.13602 3.20343 5.13602 3.65933 5.5917L10.0001 11.9329L16.341 5.59214C16.7968 5.13645 17.5358 5.13645 17.9914 5.59214C18.4475 6.04783 18.4475 6.78672 17.9914 7.24259L10.8253 14.4091C10.5974 14.6366 10.2988 14.7504 10.0001 14.7504Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowDown);
export default ForwardRef;